import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
  alpha,
} from "@mui/material";
import { useDispatch } from "react-redux";

import { Strings } from "@app/constants";
import { deleteAssignCustomers } from "../slice";

interface DeleteCustomerPopupProps {
  open: boolean;
  onClose: () => void;
  customerId: number;
  userDetailsId: number;
}

const DeleteCustomerPopup: React.FC<DeleteCustomerPopupProps> = ({
  open,
  onClose,
  customerId,
  userDetailsId,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleDelete = () => {
    if (customerId) {
      dispatch(
        deleteAssignCustomers({ customerId: customerId, userId: userDetailsId })
      );
    }
  };

  const fontFamily = Strings.fontLanguage.workSans;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle sx={{ mt: 2, textAlign: "center" }}>
        <img
          src="./assets/images/delete-customer.png"
          alt=""
          style={{
            width: 40,
            height: 40,
            objectFit: "contain",
          }}
        />
      </DialogTitle>

      <DialogContent>
        <Typography
          variant="h6"
          fontWeight="bold"
          gutterBottom
          sx={{ color: "#101828" }}
        >
          {Strings.salesPerson.deleteAssignedCustomer}
        </Typography>
        <Typography sx={{ color: "#344054" }}>
          {Strings.salesPerson.areYouSure}
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: fullScreen ? "center" : "flex-end",
          mb: 2,
          flexDirection: fullScreen ? "column" : "row",
          gap: fullScreen ? 1.5 : 0,
          px: 2,
        }}
      >
        <Button
          variant="outlined"
          onClick={onClose}
          fullWidth={fullScreen}
          sx={{
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            textTransform: "none",
            fontWeight: "600",
            fontFamily: fontFamily,
            "&:hover": {
              borderColor: theme.palette.primary.dark,
              backgroundColor: alpha(theme.palette.primary.main, 0.04),
            },
          }}
        >
          {Strings.button.cancel}
        </Button>
        <Button
          variant="contained"
          onClick={handleDelete}
          fullWidth={fullScreen}
          sx={{
            width: fullScreen ? "100%" : "28%",
            borderRadius: 0.5,
            backgroundColor: theme.palette.primary.main,
            color: "white",
            textTransform: "none",
            fontFamily: fontFamily,
            fontWeight: "600",
            "&:hover": {
              backgroundColor: theme.palette.primary.dark,
            },
          }}
        >
          {Strings.button.delete}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { DeleteCustomerPopup };
